<template>
  <el-dialog title="新建自动回复规则" :visible.sync="dialogVisible" @close="$emit('update:visible',false)"
             :close-on-click-modal="closeModal">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="200px" label-position="left">
        <el-form-item label="规则标题:">
          <el-input v-model="form.title" placeholder="请输入规则标题"></el-input>
        </el-form-item>
        <el-form-item label="关键词:">
          <div class="inputline_word">
            <el-tag
                    size="small"
                    :key="tag"
                    v-for="tag in form.keyword"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-popover
                    placement="top"
                    width="300"
                    title="添加关键词"
                    v-model="popovevisible">
              <el-input v-model="keywordAdd" placeholder="关键词最多支持15个字"></el-input>
              <div style="text-align: right; margin: 10px 0 0;">
                <el-button size="mini" type="text" @click="popovevisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="addTag">添加</el-button>
              </div>
              <span slot="reference" class="addTag">继续添加</span>
            </el-popover>
          </div>
          <div class="smallTitle">关键词支持模糊搜索</div>
        </el-form-item>
        <el-form-item label="自动回复：(随机发送)">
          <div class="common_wrap" v-if="form.response.length!==0">
            <div class="common_item common_getList" v-for="(item, index) in form.response" :key="index">
              <div class="common_textarea_wrap common_getInfo" v-if="responseStatus[index]">
                <el-input class="common_textarea" type="textarea" rows="6" v-model="form.response[index]"></el-input>
                <div class="common_textarea_action">
                  <el-button type="text" class="mr-10" @click="addUserName(index)">粉丝昵称</el-button>
                  <!--<el-button type="text">插入链接</el-button>-->
                  <el-popover
                          placement="top"
                          width="300"
                          title="插入链接"
                          v-model="linevisible">
                    <el-input v-model="linkAdd" placeholder="https://"></el-input>
                    <div style="text-align: right; margin: 10px 0 0;">
                      <el-button size="mini" type="text" @click="linevisible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="lineaddTag(index)">添加</el-button>
                    </div>
                    <el-button type="text" slot="reference">插入链接</el-button>
                  </el-popover>
                </div>
              </div>
              <div class="common_getList_box" v-else @click.stop="takeLineIndex(index)">
                {{item}}
                <i class="iconfont iconguanbi common_getList_icon" @click.stop="detelLineFn(index)"></i>
              </div>
            </div>
          </div>
          <div class="comment_btn" @click="addReply">
            <span>
              <i class="el-icon-plus"></i>添加回复
            </span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitTagFn">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "batchOpenDialog",
    props: ["visible", "editBody"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        form: {
          title: '', 	// varchar 	必填 	- 	- 	规则标题
          keyword: [], 	// 	varchar 	必填 	- 	- 	关键词(数组)
          response: [], 	// 	varchar 	必填 	- 	- 	自动回复(数组)
        },
        responseStatus: [],
        options: [],
        closeModal: false,
        popovevisible: false,
        linevisible: false,
        keywordAdd: '',
        linkAdd: '',
        is_edit: false
      };
    },
    created() {
      if (this.editBody) {
        let editBody = JSON.parse(this.editBody)
        this.is_edit = true;
        this.form.list_id = editBody.id;
        this.form.title = editBody.title;
        this.form.keyword = editBody.keyword;
        this.form.response = editBody.response;
        let responseStatus = [];
        for (let i in editBody.keyword) {
          if (i === 0) {
            responseStatus.push(true)
          } else {
            responseStatus.push(false)
          }
        }
        this.responseStatus = responseStatus
      }
    },
    methods: {
      // 自动回复
      handleClose(tag) {
        this.form.keyword.splice(this.form.keyword.indexOf(tag), 1);
      },
      addTag() {
        if (this.keywordAdd) {
          if (this.form.keyword.indexOf(this.keywordAdd) !== -1) {
            this.$message({
              message: '已经存在该关键词',
              center: true,
              type: 'warning'
            });
          } else {
            this.form.keyword.push(this.keywordAdd)
            this.popovevisible = false
            this.keywordAdd = ''
          }
        } else {
          this.$message({
            message: '请填写关键词',
            center: true,
            type: 'warning'
          });
        }
      },
      // linevisible
      lineaddTag(index) {
        if (this.linkAdd) {
          this.form.response[index] = this.form.response[index] + ' https://' + this.linkAdd + ' ';
          this.linevisible = false
          this.linkAdd = ''
        } else {
          this.$message({
            message: '请填写链接',
            center: true,
            type: 'warning'
          });
        }
      },
      addReply() {
        this.form.response.push('');
        for (let i in this.responseStatus) {
          this.responseStatus[i] = false
        }
        this.responseStatus.push(true)
        // this.responseStatus = Number(this.form.response.length)-1
      },
      takeLineIndex(index) {
        let list_ = [];
        for (let i in this.responseStatus) {
          let responseStatus = true
          if (Number(i) !== index) {
            responseStatus = false
          }
          list_.push(responseStatus)
        }
        this.responseStatus = list_
      },
      addUserName(index) {
        let val_ = this.form.response[index] + '#粉丝昵称#'
        // this.form.response[index] = val_
        this.$set(this.form.response,index,val_)
      },
      detelLineFn(index) {
        this.form.response.splice(index, 1);
        this.responseStatus.splice(index, 1)
      },
      submitTagFn() {
        if (!this.form.title) {
          this.messagebox('请填写规则标题')
          return
        }
        if (this.form.keyword.length === 0) {
          this.messagebox('请填写关键词')
          return
        }
        if (this.form.response.length === 0) {
          this.messagebox('请添加回复')
          return
        } else {
          for (let i in this.form.response) {
            if (!this.form.response[i]) {
              this.messagebox('请添加回复内容')
              return
            }
          }
        }
        // 进行提交
        let http_ = api.accounts_keyword_add
        let title_ = '添加成功'
        if(this.form.list_id){
          http_ = api.accounts_keyword_edit
          title_ = '编辑成功'
        }
        this.axios
            .post(http_, this.form)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: title_,
                  center: true,
                });
                this.$emit('changeInint')
                this.dialogVisible = false
                this.form = {
                  title: '', 	// varchar 	必填 	- 	- 	规则标题
                  keyword: [], 	// 	varchar 	必填 	- 	- 	关键词(数组)
                  response: [], 	// 	varchar 	必填 	- 	- 	自动回复(数组)
                }
              } else {
              }
            })
            .catch(response => {
              this.lock = true;
            });
      },
      messagebox(title) {
        this.$message({
          message: title,
          center: true,
          type: 'warning'
        });
      }
    }
  };
</script>
